<template>
  <div
    class="md:flex-1 rounded-2xl bg-white-005 px-6 py-4 flex flex-col"
    style="height: 428px"
  >
    <div class="flex justify-between items-center mb-4">
      <div class="font-bold text-sm lg:text-xl">Change Alert</div>
      <ShareBtn tip="Change Alert"></ShareBtn>
    </div>

    <div class="flex-1 min-h-0">
      <Skeletor class="w-full h-full rounded" v-if="loading"></Skeletor>

      <div class="rounded space-y-2 overflow-y-scroll h-full" v-else>
        <div v-for="(item, i) in state.list" :key="i">
          <router-link :to="`/dao/${item.daoPath}`">
            <div
              class="
                flex
                items-center
                justify-between
                px-2
                py-3
                hover:bg-white-005
                rounded
                cursor-pointer
                h-16
              "
            >
              <div class="flex items-center">
                <UiImg
                  class="w-10 h-10 rounded-full overflow-hidden mr-2"
                  :src="item.daoLogo"
                  :key="item.daoLogo"
                ></UiImg>
                <div>
                  <div class="font-bold text-xs lg:text-base">
                    {{ item.daoName }}
                  </div>
                  <div class="text-xs" style="color: #ffffffb3">
                    {{ formatDate(item.updateTime, 'DD/MM HH:mm') }}
                  </div>
                </div>
              </div>
              <div>
                <div v-if="item.alertType == 1 || item.alertType == 2">
                  <div class="font-bold text-right text-xs lg:text-base">
                    ${{ formatVal(item.value, { bit: 2, omit: true }) }}
                  </div>

                  <div
                    class="text-xs"
                    :style="`color:${getRateColor(
                      item.alertType == 2 ? 1 : -1,
                    )}`"
                  >
                    All-Time
                    <span class="text-rate-up" v-if="item.alertType == 2"
                      >High</span
                    ><span class="text-rate-down" v-else>Low</span>
                  </div>
                </div>
                <div
                  v-else
                  class="font-bold text-right text-xs lg:text-base"
                  :style="`color:${getRateColor(item.value)}`"
                >
                  {{ suffixNum((item.value * 100).toFixed(2)) }}% (24H)
                </div>
                <div
                  class="text-xs"
                  style="color: #5eff6a"
                  v-if="item.alertType == 5"
                >
                  New DAO Added
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { queryHomePriceLimitAlert } from '@/api/common';
import UiImg from '@/components/UiImg.vue';
import { useReqByBool } from '@/hooks';
import { getRateColor, formatDate, formatVal, suffixNum } from '@/utils';
import { inject, onMounted, onUnmounted, reactive, watch } from 'vue';
import { Skeletor } from 'vue-skeletor';
import { homeChains, homeTypes } from './constant';
import ShareBtn from './ShareBtn.vue';

const curChain = inject('curChain');
const homeState = inject('homeState');

const state = reactive({
  list: [],
  closed: false,
});

const { loadData, loading } = useReqByBool(async () => {
  const res = await queryHomePriceLimitAlert(
    homeTypes[homeState.selectedType].value,
    homeChains[homeState.selectedChain].value,
    homeState.filterStatus,
    true,
  );
  state.list = res.data.records;
});

watch(
  () => [
    homeState.selectedType,
    homeState.selectedChain,
    homeState.filterStatus,
  ],
  () => {
    loadData();
  },
);

onMounted(() => {
  loadData();
});
</script>

<style lang="scss" scoped></style>
